<style scoped>
.layout-menu-item{
   display: inline-block;
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>
<template>
    <div class="layout-menu-item" @click="eventClick" :style="fontStyle"><span>{{name}}</span></div>
</template>
<script>
export default {
    name: 'LayoutMenu',
    props: {
        blank: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: '菜单'
        },
        link: {
            type: String,
            default: ''
        },
        fontObj: {
            type: Object,
            default: ()=>{
                return {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            }
        }
    },
    computed: {
        fontStyle(){
            const {fontSize,fontStyle,fontFamily,fontWeight,color} = this.fontObj;
            return `font-size:${fontSize}px;font-style:${fontStyle};font-family:${fontFamily};font-weight:${fontWeight};color:${color}`;
        }
    },
    methods: {
        eventClick(){
            if( this.link ){
                this.blank  
                    ? window.location.href = this.link 
                    : this.$emit('update-iframe-link',this.link);
            }else{
                this.$emit('layout-menu-click',{
                    value: this.name
                });
            }
        }
    }
}
</script>